import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card card-flush pt-3 mb-5 mb-lg-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#performance-report",
  "aria-expanded": "true",
  "aria-controls": "performance-report"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Parametreler - Fark Raporu")
  ])
], -1)
const _hoisted_3 = {
  id: "performance-report",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body p-9" }
const _hoisted_5 = { class: "row g-12 mb-8" }
const _hoisted_6 = { class: "col-md-4 fv-row" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Sipariş Tarihi 1", -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Sip. Tarihi", -1)
const _hoisted_12 = { class: "col-md-4 fv-row" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Sevkiyat Tarihi 1", -1)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Sevkiyat Tarihi 2", -1)
const _hoisted_18 = { class: "col-md-4 fv-row" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Sezon", -1)
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Sipariş Şekli", -1)
const _hoisted_24 = { class: "row g-12 mb-8" }
const _hoisted_25 = { class: "col-md-4 fv-row" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Müşteri", -1)
const _hoisted_27 = { class: "col-md-4 fv-row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Üretici", -1)
const _hoisted_29 = { class: "position-relative align-items-center" }
const _hoisted_30 = { class: "col-md-4 fv-row" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Departman", -1)
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Marka", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "row g-12 mb-8" }, null, -1)
const _hoisted_37 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_38 = {
  key: 0,
  class: "card card-flush pt-3 mb-5 mb-lg-10"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Fark Raporu")
  ])
], -1)
const _hoisted_40 = { class: "card-body" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-md-12" }
const _hoisted_43 = { class: "table-responsive" }
const _hoisted_44 = { style: {"text-align":"left"} }
const _hoisted_45 = { class: "image-text" }
const _hoisted_46 = { class: "image-text" }
const _hoisted_47 = { class: "image-text" }
const _hoisted_48 = { class: "image-text" }
const _hoisted_49 = { class: "image-text" }
const _hoisted_50 = { class: "image-text" }
const _hoisted_51 = { class: "image-text" }

import { defineComponent, ref, computed } from "vue";

import Breadcrumb from "primevue/breadcrumb";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import Customer from "@/components/customers/CustomerSingleSelect.vue";
import Supplier from "@/components/suppliers/SupplierSingleSelect.vue";
import DepartmentMultiSelect from "@/components/departments/DepartmentMultiSelect.vue";
import SeasonMultiSelect from "@/components/seasons/SeasonMultiSelect.vue";
import CustomerMultiSelect from "@/components/customers/CustomerMultiSelect.vue";
import SupplierMultiSelect from "@/components/suppliers/SupplierMultiSelect.vue";
import BrandMultiSelect from "@/components/brands/BrandMultiSelect.vue";
import OrderTypeMultiSelect from "@/components/orderTypes/OrderTypeMultiSelect.vue";
import moment from "moment";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import PrintDifferenceReport from "./components/print-difference-report.vue";
//import { components } from "@/assets/ts";
import { useRouter, useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const router = useRouter();
const store = useStore();
const isActive = ref(false);
const date: any = ref();
const customers: any = ref();
const suppliers: any = ref();
const departmentIds: any = ref();
const seasonIds: any = ref();
const brandIds: any = ref([]);
const orderTypeIds: any = ref([]);

const symbol: any = ref();
const deliveryDate: any = ref();
const deliveryDateOne: any = ref();
const deliveryDateTwo: any = ref();

const orderDate: any = ref();
const orderDateOne: any = ref();
const orderDateTwo: any = ref();
const changePasswordIsActive = ref(false);
const selectedAccount = ref();
const accountName: any = ref();
const toggleModal = () => {
  isActive.value = !isActive.value;
};
const filteredDataList = computed(() => filteredData.value || []);
const filters = ref({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  orderId: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  orderQuantity: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
  },
  deliveryDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  shippingDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  customerName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  brandName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  articleNumber: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  department: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  seasonName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  orderTypeName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  order: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  supplierName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  modelCode: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
});
const selectedCustomer = (args) => {
  customers.value = args.value;
};
const selectedDepartment = (args) => {
  departmentIds.value = args.value;
};
const selectedSupplier = (args) => {
  suppliers.value = args.value;
};
const selectedSeason = (args) => {
  if (args.value) {
    seasonIds.value = args.value;
  } else {
    seasonIds.value = [];
  }
};
const selectedYear = (args) => {
  date.value = args.value;
};

const selectedBrand = (args) => {
  if (args.value && args.value.length > 0) {
    brandIds.value = args.value.map((item) => item.value);
  } else {
    brandIds.value = [];
  }
};

const selectedOrderType = (args) => {
  if (args.value && args.value.length > 0) {
    orderTypeIds.value = args.value.map((item) => item.value);
  } else {
    orderTypeIds.value = [];
  }
};

const differenceReportList = computed(
  () => store.state.ReportModule.differenceReport.value || []
);

const send = () => {
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
  var model = {
    orderDateOne: orderDateOne.value,
    orderDateTwo: orderDateTwo.value,
    deliveryDateOne: deliveryDateOne.value,
    deliveryDateTwo: deliveryDateTwo.value,
    customerIds: customers.value ? customers.value.map((f) => f.id) : [],
    supplierIds: suppliers.value ? suppliers.value.map((f) => f.id) : [],
    departmentIds: departmentIds.value
      ? departmentIds.value.map((f) => f.value)
      : [],
    seasonIds: seasonIds.value ? seasonIds.value.map((f) => f.value) : [],
    brandIds: brandIds.value || [],
    orderTypeIds: orderTypeIds.value || [],
    currencyTypeId: 1,
  };
  symbol.value = model.currencyTypeId == 1 ? "€" : "$";
  store.dispatch(Actions.DIFFERENCE_REPORT_LIST, model).then(() => {
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  });
};

const filteredData = ref();
const filterData = (data) => {
  filteredData.value = data;
};
const exportExcel = () => {
  import("xlsx").then((xlsx) => {
    const data = filteredData.value.map((x) => {
      const orderLinePrice = parseFloat(x.orderLinePrice);
      const orderQuantity = parseInt(x.orderQuantity);
      const shipped = parseInt(x.shipped);

      // Hesaplamaları string olarak yapalım
      const totalOrderAmount =
        (orderLinePrice * orderQuantity)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
          .replace(/\.(\d+)$/, ",$1") +
        " " +
        (symbol.value || "€");

      const totalShippedAmount =
        (orderLinePrice * shipped)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
          .replace(/\.(\d+)$/, ",$1") +
        " " +
        (symbol.value || "€");

      return {
        "Sipariş Numarası": x.orderId,
        Tarih: x.orderDate,
        Müşteri: x.customerName,
        Marka: x.brandName,
        Departman: x.department,
        Üretici: x.supplierName,
        "Model Kodu": x.modelCode,
        Artikel: x.articleNumber,
        Order: x.order,
        "Sipariş Şekli": x.orderTypeName,
        "Yükleme Şekli": x.shippingTypeName,
        Sezon: x.seasonName,
        "Yükleme Tarihi": moment(x.shippingDate).format("DD.MM.YYYY"),
        "Varış Tarihi": moment(x.deliveryDate).format("DD.MM.YYYY"),
        "Sipariş Adedi": String(orderQuantity),
        Fiyat: orderLinePrice
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
          .replace(/\.(\d+)$/, ",$1")
          .toString(),
        "Toplam Sipariş Tutarı": totalOrderAmount,
        "Sevk Edilen": String(shipped),
        "Toplam Sevk Tutarı": totalShippedAmount,
        Fark: String(orderQuantity - shipped),
        "Fark Nedeni": x.differenceReasonName,
        Açıklama: x.orderExplain,
      };
    });
    const ws = xlsx.utils.json_to_sheet(data);
    const wb = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, "sheet01");
    xlsx.utils.sheet_add_aoa(
      ws,
      [
        [
          "Toplam",
          filteredData.value
            .map((f) => f.orderQuantity)
            .reduce(function (a, b) {
              return a + b;
            }, 0),
          "",
          filteredData.value
            .map((f) => f.orderLinePrice * f.orderQuantity)
            .reduce(function (a, b) {
              return a + b;
            }, 0)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
            .replace(/\.(\d+)$/, ",$1")
            .toString() +
            " " +
            (symbol.value == null ? " €" : symbol.value),

          filteredData.value
            .map((f) => f.shipped)
            .reduce(function (a, b) {
              return a + b;
            }, 0),
          filteredData.value
            .map((f) => f.orderLinePrice * f.shipped)
            .reduce(function (a, b) {
              return a + b;
            }, 0)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
            .replace(/\.(\d+)$/, ",$1")
            .toString() +
            " " +
            (symbol.value == null ? " €" : symbol.value),
          filteredData.value
            .map((f) => f.orderQuantity - f.shipped)
            .reduce(function (a, b) {
              return a + b;
            }, 0),
        ],
      ],
      { origin: "N" }
    );
    const fileName = `difference_report_${moment(new Date()).format()}.xlsx`;

    xlsx.writeFile(wb, fileName);
  });
};
const print = () => {
  toggleModal();
};

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((orderDateOne).value = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, orderDateOne.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((orderDateTwo).value = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, orderDateTwo.value]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((deliveryDateOne).value = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, deliveryDateOne.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((deliveryDateTwo).value = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, deliveryDateTwo.value]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(SeasonMultiSelect, {
                    class: "col-md-12",
                    onChangeSeason: selectedSeason
                  })
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(OrderTypeMultiSelect, {
                    class: "col-md-12",
                    onChangeOrderType: selectedOrderType
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(CustomerMultiSelect, { onChangeCustomer: selectedCustomer })
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createVNode(SupplierMultiSelect, {
                  class: "col-md-12",
                  onChangeSupplier: selectedSupplier
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createVNode(DepartmentMultiSelect, {
                    class: "col-md-12",
                    onChangeDepartment: selectedDepartment
                  })
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createVNode(BrandMultiSelect, {
                    class: "col-md-12",
                    onChangeBrand: selectedBrand
                  })
                ])
              ])
            ])
          ]),
          _hoisted_36
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("button", {
          id: "performance-report_submit",
          ref: "submitButtonSettings",
          class: "btn btn-primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (send()))
        }, " Görüntüle ", 512)
      ])
    ]),
    (_unref(differenceReportList).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_DataTable, {
                    showGridlines: "",
                    onValueChange: filterData,
                    value: _unref(store).state.ReportModule.differenceReport.value,
                    removableSort: "",
                    class: "p-datatable-sm",
                    responsiveLayout: "scroll",
                    filters: filters.value,
                    "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => ((filters).value = $event)),
                    stripedRows: "",
                    filterDisplay: "menu",
                    dataKey: "id",
                    paginator: true,
                    rows: 50,
                    style: {"width":"max-content","min-width":"-webkit-fill-available","font-size":"11px","max-width":"90% !important","font-weight":"bold"}
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_component_Button, {
                          icon: "pi pi-print",
                          class: "p-button-rounded btn btn-primary",
                          style: {"padding":"0","margin-right":"5px"},
                          onClick: toggleModal
                        }),
                        _createVNode(_component_Button, {
                          icon: "pi pi-file-excel",
                          class: "p-button-rounded btn btn-primary",
                          style: {"padding":"0"},
                          onClick: exportExcel
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "orderId",
                        header: "Sipariş No",
                        filterMatchMode: "contains",
                        style: {"min-width":"5rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_45, _toDisplayString(data.orderId), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "customerName",
                        header: "Müşteri",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }),
                      _createVNode(_component_Column, {
                        field: "brandName",
                        header: "Marka",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_46, _toDisplayString(data.brandName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "department",
                        header: "Departman",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_47, _toDisplayString(data.department), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "supplierName",
                        header: "Üretici",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_48, _toDisplayString(data.supplierName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "modelCode",
                        header: "Model Kodu",
                        filterMatchMode: "contains",
                        style: {"min-width":"6rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_49, _toDisplayString(data.modelCode), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "articleNumber",
                        header: "Artikel",
                        filterMatchMode: "contains",
                        style: {"min-width":"3rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_50, _toDisplayString(data.articleNumber), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "order",
                        header: "Order",
                        filterMatchMode: "contains",
                        style: {"min-width":"5rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_51, _toDisplayString(data.order), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "orderTypeName",
                        header: "Sipariş Şekli",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.orderTypeName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "shippingTypeName",
                        header: "Yükleme Şekli",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.shippingTypeName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "seasonName",
                        header: "Sezon",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.seasonName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "shippingDate",
                        header: "Yükleme Tarihi",
                        sortable: "true",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(_unref(moment)(data.shippingDate).format("DD.MM.YYYY")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "deliveryDate",
                        header: "Sevk Tarihi",
                        sortable: "true",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(_unref(moment)(data.deliveryDate).format("DD.MM.YYYY")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "orderQuantity",
                        header: "Sipariş Adedi",
                        class: "text-end",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.orderQuantity), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "orderLinePrice",
                        header: "Fiyat",
                        class: "text-end",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(parseFloat(data.orderLinePrice)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "orderLinePrice",
                        header: "Top. Sip. Tutarı",
                        class: "text-end",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(parseFloat(data.orderLinePrice * data.orderQuantity)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "shipped",
                        header: "Sevk Edilen",
                        class: "text-end",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.shipped), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "shipped",
                        header: "Top. Sevk Tutarı",
                        class: "text-end",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(parseFloat(data.orderLinePrice * data.shipped)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "shipped",
                        header: "Fark",
                        class: "text-end",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(String(data.orderQuantity - data.shipped)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "shipped",
                        header: "Fark Nedeni",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.differenceReasonName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        header: "Açıklama",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.orderExplain), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ColumnGroup, { type: "footer" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                footer: "",
                                colspan: 13,
                                footerStyle: "text-align:right"
                              }),
                              _createVNode(_component_Column, {
                                footer: 
                      _unref(filteredDataList)
                        .map((f) => f.orderQuantity)
                        .reduce(function (a, b) {
                          return a + b;
                        }, 0)
                    ,
                                class: "text-end",
                                style: {"min-width":"6rem"}
                              }, null, 8, ["footer"]),
                              _createVNode(_component_Column, { footer: "" }),
                              _createVNode(_component_Column, {
                                footer: 
                      _unref(filteredDataList)
                        .map((f) => f.orderLinePrice * f.orderQuantity)
                        .reduce(function (a, b) {
                          return a + b;
                        }, 0)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1.')
                        .replace(/\.(\d+)$/, ',$1') + ' €'
                    ,
                                class: "text-end",
                                style: {"min-width":"7rem"}
                              }, null, 8, ["footer"]),
                              _createVNode(_component_Column, {
                                footer: 
                      _unref(filteredDataList)
                        .map((f) => f.shipped)
                        .reduce(function (a, b) {
                          return a + b;
                        }, 0)
                    ,
                                class: "text-end",
                                style: {"min-width":"6rem"}
                              }, null, 8, ["footer"]),
                              _createVNode(_component_Column, {
                                footer: 
                      _unref(filteredDataList)
                        .map((f) => f.orderLinePrice * f.shipped)
                        .reduce(function (a, b) {
                          return a + b;
                        }, 0)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1.')
                        .replace(/\.(\d+)$/, ',$1') + ' €'
                    ,
                                class: "text-end",
                                style: {"min-width":"6rem"}
                              }, null, 8, ["footer"]),
                              _createVNode(_component_Column, {
                                footer: 
                      _unref(filteredDataList)
                        .map((f) => f.orderQuantity - f.shipped)
                        .reduce(function (a, b) {
                          return a + b;
                        }, 0)
                    ,
                                class: "text-end",
                                style: {"min-width":"6rem"}
                              }, null, 8, ["footer"]),
                              _createVNode(_component_Column, { footer: "" }),
                              _createVNode(_component_Column, { footer: "" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "filters"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (isActive.value)
      ? (_openBlock(), _createBlock(PrintDifferenceReport, {
          key: 1,
          isActive: isActive.value,
          data: filteredData.value,
          currencyType: symbol.value,
          onChangeReceipt: toggleModal
        }, null, 8, ["isActive", "data", "currencyType"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})